import { Stack, Typography } from "@mui/material";
import { convertISODate } from "@entrilia/shared/utilities/dateUtils";
import { ContactStatus } from "../../../../api/types/fundStructureTypes";
import { contactStatusCaptionsMap } from "../../../../utilities/enumCaptions";

export const ContactPortalStatus = ({
  status,
  registrationDate,
}: {
  status: ContactStatus;
  registrationDate?: string;
}) => {
  return (
    <Stack>
      <Typography>{contactStatusCaptionsMap.get(status) ?? "Not Registered"}</Typography>
      {registrationDate && status === ContactStatus.Registered && (
        <Typography variant="caption" color="textSecondary">
          {convertISODate(registrationDate)}
        </Typography>
      )}
    </Stack>
  );
};
